<div class="content">
  <div class="plate plate-light_blue p-0 m-2" style="max-width:900px;">
    <div class="plate plate-dark_blue swoosh swoosh-cfi-home">
      <div>
        <h1>Course Progress Sharing Request</h1>
      </div>
    </div>

    <div class="plate-header p-4 text-center" ng-if="!loading">
      <h2 *ngIf="invitation">
        {{invitation.instructor.user.firstName}}
        {{invitation.instructor.user.lastName}}
        has invited <span class="text-wrap">{{invitation.email}}</span> to share your Sporty's Course Progress.
      </h2>
      <div *ngIf="user !== null">
        <div *ngIf="invitation && !loading" class="d-flex flex-column" style="justify-content: center; width:100%;">
          <div *ngIf="!validInvitation()" class="text-danger">
            This progress sharing request has been sent to {{invitation.email}}. Please verify with your instructor that
            they have the correct email address associated with your Sporty's Pilot Training account.
            <span *ngIf="!user">Please verify if you're logged in.</span>
          </div>
          <div *ngIf="acceptedInvitation()" class="text-info pb-2">
            The invitation has been accepted.
          </div>
          <div *ngIf="validInvitation() && !acceptedInvitation()"></div>

          <div>
            <button (click)="accept($event)" class="btn btn-round btn-primary m-auto" [disabled]="!validInvitation() || acceptedInvitation()">
              Accept Invitation
            </button>
          </div>
        </div>
        <div *ngIf="user">
          <a [routerLink]="['/home']" class="btn btn-link">My Courses</a>
        </div>
      </div>
      <div *ngIf="!invitation && !loading" class="text-center">
        Invitation not found.
      </div>
      <div *ngIf="!loading && user === null && !showSignup && !showLoginForm" class="d-flex"
        style="justify-content: space-between; width:100%;">

        <div>
          Log in with your Sporty’s Account to accept the invitation. Your instructor will then be able to track your
          video and test prep results as your progress through the course. If you don't have access to one of Sporty's
          pilot training courses, click the buy now button to enroll.
        </div>
        <div class="d-flex">
          <button class="btn btn-link" href (click)="toggleLoginForm($event)" style="margin: 0px 24px;">Login</button>
          <!-- <a class="btn btn-round btn-primary" href (click)="signup($event)">Create a free account</a> -->
          <a class="btn btn-round btn-primary" href="https://www.sportys.com/learn-to-fly/sporty-s-courses.html"
            target="_blank">Buy Now</a>
        </div>
      </div>
      <ng-container *ngIf="showLoginForm">
        <app-login (onComplete)="onLoginFormComplete()" (onCancel)="onLoginFormCancel()"
          (onShowSignupForm)="onShowSignupForm()">
        </app-login>
      </ng-container>
      <div *ngIf="user === null && showSignup">
        <app-signup [showCfiCredentials]="false" [showCancelButton]="true" [course]="course"
          submitButtonLabel="Submit" (onCompleted)="onSignupCompleted($event)" (onCancel)="onSignupCancel($event)"
          (onRegisterCompleted)="onRegisterCompleted($event)"></app-signup>
      </div>
    </div>
  </div>
</div>
